/**
 * Resources related to possible auth related errors from Azure Active Directory Security Token Service (AADSTS)
 * https://learn.microsoft.com/en-us/azure/active-directory/develop/reference-aadsts-error-codes
 */
import { BrowserAuthError, BrowserAuthErrorMessage, InteractionRequiredAuthError } from '@azure/msal-browser';
import { App_ID_Map } from '../../../../utilities';
// list of known conditional access related errors
export const CAErrorCodes = {
    BlockAccess: ['AADSTS50131', 'AADSTS53003', 'AADSTS530032']
};
export class AuthError {
    static isCABlockAccessError(error) {
        return AuthError.isInteractionRequiredError(error) && CAErrorCodes.BlockAccess.some(code => error.errorMessage.includes(code));
    }
    static isInteractionRequiredError(error) {
        return error instanceof InteractionRequiredAuthError;
    }
    static isInteractionInProgressError(error) {
        return error instanceof BrowserAuthError && error.errorCode === BrowserAuthErrorMessage.interactionInProgress.code;
    }
    /**
     * Specially logic added by MyApps team. Consult with Xubin Zheng / MyApps team for more info
     * Here, they do not want to do interaction when encountering this error for Iamux and AppManagement app id.
     *
     * Note that this only applies to MyApps
     */
    static isSpecialMyAppLogic(error, scopes, clientId) {
        return clientId === App_ID_Map.MyApps && AuthError.isInteractionRequiredError(error) &&
            (scopes[0]?.includes(App_ID_Map.Iamux) ||
                scopes[0]?.includes(App_ID_Map.AppManagement));
    }
}
//# sourceMappingURL=AuthError.js.map